<template>
  <v-toolbar flat>
    <v-chip v-if="selectedData.length > 0" close @click:close="clearSelected">
      {{ `${selectedData.length} data(s) selected` }}
    </v-chip>

    <v-spacer />
    <template>
      <v-btn
        color="primary"
        class="mb-2 rounded-pill elevation-0"
        @click="openApproveModal(true)"
        :style="{ 'margin-right': '10px' }"
        :disabled="loading"
      >
        Force Active
      </v-btn>
      <v-btn
        color="warning"
        icon
        class="mb-2"
        @click="getData"
        :loading="loading"
        :disabled="loading"
        :style="{ 'margin-right': '10px' }"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      
      <v-menu offset-y rounded="lg" transition="slide-y-transition" bottom left>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="warning" class="mb-2" icon dark v-bind="attrs" v-on="on">
          <v-icon light size="20">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item link @click="$emit('exportItem')">
          <v-list-item-icon>
            <v-icon>mdi-file-excel</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Export to excel</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    </template>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    selectedData: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    clearSelected() {
      this.$emit("clearSelected");
    },
    openApproveModal(value) {
      this.$emit("openApproveModal", value);
    },
    getData() {
      this.$emit("getData");
    },
  },
};
</script>
